var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    width: '1920px',
    height: '1080px',
    'transformOrigin':'left top',
    'transform':("scale(" + _vm.scalseNum + ")"),
    '-webkit-transform':("scale(" + _vm.scalseNum + ")"),
    '-moz-transform':("scale(" + _vm.scalseNum + ")"),
    '-o-transform':("scale(" + _vm.scalseNum + ")"),
    '-ms-transform':("scale(" + _vm.scalseNum + ")")
  }),attrs:{"id":"SystemDevelopmentDivisionTerimel"}},[_c('div',{staticClass:"header main-header"},[_c('div',{staticClass:"header-left"},[_c('div',{staticClass:"site-name xx"},[_vm._v("\n        "+_vm._s(_vm.name)+"\n      ")]),_c('span',{staticClass:"xx"},[_vm._v("更新时间："+_vm._s(_vm.cutOffDate))])]),_c('div',{staticClass:"header-right"},[_c('span',{staticClass:"goback",on:{"click":_vm.goback}},[_vm._v("返回")])])]),_c('div',{staticClass:"main-body"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }